import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { IonItem, IonLabel } from '@ionic/angular/standalone';
import { TranslateModule } from '@ngx-translate/core';
import { IVehicle } from '@okcargo-apps/shared-domain';
import { ECapabilities } from '@okcargo-apps/shared-domain-ionic';
import { AccountService } from '../../account';
import { VehicleDeleteActionComponent } from '../vehicle-delete-action/vehicle-delete-action.component';
import { VehicleEditActionComponent } from '../vehicle-edit-action/vehicle-edit-action.component';

@Component({
  selector: 'lib-vehicle-item',
  templateUrl: './vehicle-item.component.html',
  styleUrls: ['./vehicle-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IonItem, IonLabel, TranslateModule, VehicleEditActionComponent, VehicleDeleteActionComponent],
})
export class VehicleItemComponent {
  public readonly vehicle = input.required<IVehicle>();

  private readonly accountService = inject(AccountService);

  /** The item owns the vehicle, so it decides which actions can be performed on it. */
  protected readonly canManageVehicle = computed(() => this.accountService.hasCapability(ECapabilities.CRUD_VEHICLES));
}
